import { useParams } from "react-router-dom";
import useTeams from "./useTeams";

/**
 *
 * @returns {{teams: ?TeamCollection, team: ?Team, teamsQuery: UseQueryResult<*, unknown>}}
 */
export default function useTeam() {
  const { teams, teamsQuery } = useTeams();
  const { team: teamIdOrSlug } = useParams();

  let team = null;
  if (teams && teamIdOrSlug) {
    team = teams.getTeamByIdOrSlug(teamIdOrSlug);
  }

  return { team, teams, teamsQuery };
}
